import { Dorothy } from "../components/Dorothy";
import { Movement } from "../components/Movement";

export function DorothyPage() {
  return (
    <>
      <Dorothy />
      <Movement />
    </>
  );
}
